'use client';

import { usePathname } from 'next/navigation';

export default function RenderAnalyticsScript() {
    const pathname = usePathname();

    // Conditionally load a script only on the home page
    if (pathname === '/temp-login' || process.env.NEXT_PUBLIC_NODE_ENV === 'development') return null;

    return (
        <script src={`https://assets.adobedtm.com/58d4dfc81ba0/d1119d43f7c6/launch-${process.env.NEXT_PUBLIC_ADOBE_ANALYTICS_KEY}.min.js`} async></script>
    );
}
